import React from 'react';

type AnimatedCheckmarkProps = {
  fill: string;
  size: number;
  strokeWidth: number;
  strokeColor: string;
};

export const AnimatedCheckmark: React.FC<AnimatedCheckmarkProps> = ({ fill, size, strokeColor, strokeWidth }) => {
  const radiusSize = size - strokeWidth * 2;
  const circumference = radiusSize * 2 * Math.PI;
  const circleRef = React.useRef<SVGCircleElement>(null);
  const checkmarkRef = React.useRef<SVGPolylineElement>(null);

  React.useEffect(() => {
    if (circleRef.current) {
      setTimeout(() => {
        if (circleRef.current) {
          circleRef.current.style.strokeDashoffset = '0';
        }
      }, 100);
    }
    if (checkmarkRef.current) {
      setTimeout(() => {
        if (checkmarkRef.current) {
          checkmarkRef.current.style.strokeDashoffset = '0';
        }
      }, 100);
    }
  }, [circumference]);

  return (
    <svg height={size} width={size} viewBox={`0 0 100 100`} xmlns="http://www.w3.org/2000/svg">
      <circle
        cx={50}
        cy={50}
        r={50 - strokeWidth}
        strokeWidth={strokeWidth}
        stroke={strokeColor}
        strokeLinecap="round"
        fill={fill}
        style={{
          strokeDasharray: `${circumference} ${circumference}`,
          strokeDashoffset: circumference,
          transition: 'all 1s ease-in-out',
        }}
        ref={circleRef}
      />
      <polyline
        points="35 50 45 60 65 35"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        fill="none"
        ref={checkmarkRef}
        style={{
          strokeDasharray: `100 100`,
          strokeDashoffset: 100,
          transition: 'all 1s ease-in-out',
          transitionDelay: '0.45s',
        }}
      />
    </svg>
  );
};
